import React from 'react';
import { Navigate } from 'react-router-dom';

export default function SuperadminRoute({ children, user }) {
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.rol !== 'superadmin') {
    return <Navigate to="/" replace />;
  }

  return children;
}